
export default function RefundPolicyPage() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/a5e7a8d75a8d5f4ed40cacf34a3df597/11df6f839158c987a838fe6484b0b0b8.jpeg" 
              alt="Vortex Digital Assets" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-semibold text-gray-900">
              Vortex Digital Assets
            </span>
          </a>
          
          <a 
            href="/"
            className="text-sm font-medium text-gray-600 hover:text-teal-600 transition-colors"
          >
            Back to Home
          </a>
        </div>
      </nav>

      {/* Content */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="mb-8">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Refund Policy</h1>
            <p className="text-sm text-gray-500">Last updated: January 2026</p>
          </div>
          
          <div className="bg-white rounded-2xl p-12 shadow-sm border border-gray-200">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed">
                Vortex Digital Asset provides immediate digital delivery of all credits and assets. Due to the nature of instant provisioning and the immediate consumption of digital services, <strong>all sales are final</strong>. We do not offer cash refunds once a transaction is successfully processed.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mt-6">
                If a technical error occurs and your credits are not delivered, our technical team will manually provision your account within 24 hours of receiving a support ticket.
              </p>
              
              <div className="mt-8 bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Need Support?</h3>
                <p className="text-base text-gray-700 mb-4">
                  If you experience any technical issues with your order, please contact our 24/7 support team immediately.
                </p>
                <div className="space-y-2">
                  <a 
                    href="mailto:sales.vortexdigital@gmail.com" 
                    className="flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium"
                  >
                    <i className="ri-mail-line"></i>
                    sales.vortexdigital@gmail.com
                  </a>
                  <a 
                    href="https://wa.me/14472962159" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium"
                  >
                    <i className="ri-whatsapp-line"></i>
                    +1 (447) 296-2159
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <button 
              onClick={scrollToTop}
              className="text-teal-600 hover:text-teal-700 font-medium flex items-center gap-2 mx-auto"
            >
              <i className="ri-arrow-up-line"></i>
              Back to Top
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2026 Vortex Digital Assets. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/terms-of-service" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
              <a href="/refund-policy" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Refund Policy
              </a>
              <a href="/privacy-policy" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
